<template>
  <div>
    <justifi-payment-provisioning
      :business-id="justifiBusinessId"
      :auth-token="webComponentToken"
      form-title=""
    ></justifi-payment-provisioning>
  </div>
</template>
<script>
export default {
  props: {
    justifiBusinessId: {
      type: String,
      required: true
    },
    webComponentToken: {
      type: String,
      required: true
    }
  },
  mounted() {
    const paymentProvisioning = document.querySelector("justifi-payment-provisioning");
    paymentProvisioning.addEventListener("submit-event", this.submitEvent);
    paymentProvisioning.addEventListener("click-event", this.clickEvent);
    paymentProvisioning.addEventListener("error-event", this.errorEvent);
  },
  methods: {
    submitEvent(event) {
      console.log("provisioning complete", event);
      window.location.assign('/setup/payments/status');
    },
    clickEvent(event) {
      console.log("button clicked", event);
      let name = event.detail.name;

      if (name === "nextStep") {
        console.log("Next step button clicked");
      } else if (name === "previousStep") {
        console.log("Previous step button clicked");
      }
    },
    errorEvent(event) {
      console.error("error-event", event);
    },
  }
};
</script>
<style scoped>
</style>
